import SLAViewMode from '@nile/banyan/src/Components/SLAViewMode';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import { BoxContainer } from '@nile/banyan/src/Utils/style';
import { Tag, AccessControl, getTranslatedText } from '@nile/components';
import { DeleteModal } from '@nile/components/src';
import {
  Button,
  ButtonGroup,
  Heading,
  Link,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@superops/ui-design-system';
import React, { Component } from 'react';
import styled from 'styled-components';
import { isEqual } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { SuperSortable } from '@nile/components/src/SuperSortable/SuperSortable';

class SLAPolicyCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      value: [],
      selectedSLAPolicy:
        props.slapolicies.length > 0 ? props.slapolicies[0] : [],
      selectedItems:
        props.slapolicies.length > 0 ? [props.slapolicies[0].id] : []
    };
  }

  renderSubItem = (item) => {
    this.setState({ selectedSLAPolicy: item });
  };

  deleteSLAPolicy = (id) => {
    this.props.deleteSLA({
      variables: { id }
    });
  };

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
    }
  };

  handleSLAPolicyChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  render() {
    const { selectedSLAPolicy, selectedItems } = this.state;

    const {
      editSLA,
      slapolicies,
      intl,
      isMSPProduct,
      organizeSLA,
      setSLAPolicies
    } = this.props;

    const processedAllItems = processData(slapolicies, 'id');
    const renderSubItems = this.renderSubItem;

    return (
      <div className="fh">
        <div className="fx white-transparent-bg ch-20">
          <div className="fx no-scroll white-transparent-bg w30 border-right p20 fh">
            <div className="full-width">
              <div className="sticky-search">
                <AutoComplete
                  options={processedAllItems}
                  handleChange={this.handleSLAPolicyChange}
                />
              </div>
              <div className="cascade-list ch-50">
                <SuperSortable
                  list={slapolicies}
                  className="sort-wrapper"
                  onDragEnd={(li) => {
                    const sortedSlaItems = li?.map((item, index) => {
                      return {
                        sla: {
                          id: item.id
                        },
                        slaOrder: index
                      };
                    });
                    organizeSLA({
                      variables: { input: sortedSlaItems }
                    });
                    setSLAPolicies(li);
                    // this.setSelectedItems(sortedSlaItems.map);
                  }}
                  animation={200}
                  disabled={isMSPProduct}
                >
                  {slapolicies.map(function(item) {
                    const { id, name } = item;
                    return (
                      <ResourceItem
                        id={id}
                        key={id}
                        accessibilityLabel={`View details for ${name}`}
                        customClassName="list-no-pad"
                        isSelected={selectedSLAPolicy?.id === id}
                        onClick={() => renderSubItems(item)}
                      >
                        <div className="flex actr g5">
                          {!isMSPProduct && (
                            <SuperSortable.DragHandle className="dragHandle" />
                          )}
                          <div className="fw list-item">
                            <TextStyle variation="strong">{name} </TextStyle>
                          </div>
                          {item.clients && item.clients.length > 0 ? (
                            <div className="iconHolder">
                              <SVGIcon name="ArrowRight" />
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </ResourceItem>
                    );
                  })}
                </SuperSortable>
              </div>
            </div>
          </div>
          {selectedSLAPolicy && (
            <div className="p2040 scroll w70">
              <div className="fg1 full-height">
                <div className="flex h90px">
                  <div className="fx2">
                    <div className="flex center">
                      <Heading element="h2">{selectedSLAPolicy.name}</Heading>
                      <Tag
                        className="ml8 uppercase f-12"
                        active={selectedSLAPolicy.active}
                        background={selectedSLAPolicy.active ? '#E7F6D7' : ''}
                        color={selectedSLAPolicy.active ? '#4F712B' : ''}
                      >
                        {selectedSLAPolicy.active ? (
                          <FormattedMessage id="admin.slaPolicy.status.active" />
                        ) : (
                          <FormattedMessage id="admin.slaPolicy.status.inActive" />
                        )}
                      </Tag>
                    </div>
                    <p className="desc mt-10">
                      {selectedSLAPolicy.description}
                    </p>
                  </div>
                  <div
                    data-qa="editBtn"
                    className="fx jend self-start SLA-Policy-Actions"
                  >
                    <ButtonGroup>
                      <AccessControl
                        roleToCheck="slaPolicy.delete"
                        render={
                          <DeleteModal
                            id="deleteSLA"
                            description={getTranslatedText(
                              intl,
                              'admin.slaPolicy.deleteMessage'
                            )}
                            handleDeleteConfirmation={() =>
                              this.deleteSLAPolicy(selectedSLAPolicy.id)
                            }
                            title={getTranslatedText(
                              intl,
                              'admin.slaPolicy.deleteTitle'
                            )}
                          />
                        }
                      />
                      <AccessControl
                        roleToCheck="slaPolicy.edit"
                        render={
                          this.props?.contractNew ? (
                            <Button
                              onClick={() => editSLA(selectedSLAPolicy.id)}
                              icon={<SVGIcon name="Edit" />}
                            />
                          ) : (
                            <Link
                              removeUnderline
                              url={
                                '#/onboard/sla/' +
                                selectedSLAPolicy.id +
                                '/edit'
                              }
                            >
                              <SVGIcon name="Edit" />
                            </Link>
                          )
                        }
                      />
                    </ButtonGroup>
                  </div>
                </div>
                <SLAViewMode sla={selectedSLAPolicy} />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(SLAPolicyCascade);
